import { Flex } from 'antd'
import React from 'react'
import { AppSessionType } from '~/features/appSession/common'
import { IconGroup } from '~/features/shared/components'
import { Icon } from '~/features/shared/icons'

type Props = {
  appSession: AppSessionType
}

export const TabPostsIcon: React.FC<Props> = ({ appSession }) => {
  const isLinkedin = appSession.values.onboarding?.platform?.linkedin
  const isInstagram = appSession.values.onboarding?.platform?.instagram
  const isTwitter = appSession.values.onboarding?.platform?.twitter
  const isFacebook = appSession.values.onboarding?.platform?.facebook
  const isGoogleBusinessProfile = appSession.values.onboarding?.platform?.gmb

  const icons = [
    isInstagram && 'instagram',
    isFacebook && 'facebook-square',
    isTwitter && 'x-square',
    isLinkedin && 'linkedin',
    isGoogleBusinessProfile && 'gmb',
  ]
    .filter(Boolean)
    .map((name, index) => (
      <Icon
        key={name}
        name={name as any}
        className={index === 0 ? '' : 'ml-1'}
        style={{ fontSize: '16px' }}
      />
    ))

  return (
    <Flex className="h-full" align="center">
      <IconGroup>{icons}</IconGroup>
    </Flex>
  )
}
